import { fansupportPublic } from "./index";
/**
 * Asynchronously fetches tournaments from the server based on specified filters.
 *
 * @async
 * @function
 * @name getTournament
 * @param {Object} options - An object containing the following properties:
 * @param {string} options.sportId - The ID of the sport to filter tournaments by.
 * @param {string} options.countryId - The ID of the country to filter tournaments by.
 * @return {Promise<Object>} A Promise that resolves to tournament data in JSON format.
 * @throws {Error} If an error occurs during the request.
 */
export const getTournament = async ({sportId, countryId}) => {
    return fansupportPublic.get('/sport/filter',{ params: { 
        sportId,
        countryId,
    } } )
} 